<template>
  <div class="pub-option">
    <div class="card grow" @click="cardClicked">
      <div class="pub-option-icon">
        <img
          :src="'/images/earn-snaps/' + service.name + '.svg'"
          class="pub-option-icon-img"
        />
      </div>
      <div class="pub-option-title">{{ service.title }}</div>
      <div class="pub-option-description" v-html="service.description"></div>

      <!-- <div class="details">
      <div class="price">${{ service.price }}</div>
      <div class="snap-bonus">
        <points :count="service.snap_bonus"></points>bonus
      </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import Points from "@/components/Points/Tag";

export default {
  name: "ServiceOption",
  props: ["service"],
  components: { Points },
  data: function () {
    return {
      descriptions: {},
      description: null,
    };
  },
  async created() {},
  methods: {
    cardClicked() {
      switch (this.service.name) {
        case "read":
          this.$router.push("/browse");
          break;
        case "friends":
          this.$router.push("/friends");
          break;
        case "social":
          this.$router.push("/social/earn");
          break;
        case "publish":
          this.$router.push("/publish");
          break;
        case "refer":
          this.$store.commit("showReferProgram");
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.pub-option {
  float: left;
  width: 50%;
}

.card {
  min-height: 210px;
  background: #fff;
  box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);
  margin: 12px 16px;
  padding: 0px 0;
  padding-bottom: 0 !important;
  border-radius: 8px;
  font-family: "Source Sans Pro";
}

.grow {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.grow:hover {
  transform: scale(1.03);
}

.pub-option-icon {
  text-align: center;
  margin: 0px 0 0px 0;
  padding-top: 20px;
}
.pub-option-icon-img {
  width: 52px;
}

.pub-option-title {
  padding: 0px 0 0 0;
  font-size: 19pt;
  color: darken($color-blue, 0%);
  color: #111;
  font-weight: 600;
  text-align: center;
  //padding-left: 60px;
}
.pub-option-description {
  font-size: 12pt;
  padding: 12px 40px 0px 40px;
}

.pub-option-pricing-container {
  margin-top: 8px;
  border-top: 1px solid #eee;
  padding-top: 12px;
}

.pub-option-pricing {
  padding: 0px;
  padding-bottom: 16px;
  // padding-left: 50px;
  // width: 350px;
  // margin: 0 auto;
}

.pub-option-price {
  float: right;
  width: 150px;
}
.pub-option-price-label {
  font-size: 10.5pt;
  text-transform: uppercase;
  color: #666;
}
.pub-option-price-number {
  font-size: 13.5pt;
  font-weight: 600;
  text-transform: uppercase;
  color: #111;
}

.number-agency {
  text-decoration: line-through;
  color: #666 !important;
}

.member-label {
  color: darken(#e08d00, 4%);
}
.snaps-label {
  color: darken(#e08d00, 4%);
}

// Points Tag
.points-container {
  display: flex;
  justify-content: left;
  border-radius: 28px;
  padding: 3px 0 0 0;
  margin-left: -2px;
  margin-top: -1px;
}
.border {
  border: 2px solid darken($color-sidebar, 4%) !important;
}
.points-icon {
  flex-grow: 0;
  padding-top: 0px;
  margin-top: -1px;
}
.points-icon-img {
  width: 22px;
  color: $color-snaps;
  font-size: 18pt !important;
}
.points {
  flex-grow: 0;
  color: darken($color-snaps, 0%);
  margin-left: 5px;
  font-size: 13pt !important;
  font-weight: 600;
  font-family: "Source Sans Pro";
}
</style>